/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-26 10:46:00
 * @LastEditTime: 2022-07-29 11:13:23
 * @LastEditors: chenguobiao
 */
export class Timer {
  isSuspend = false
  timer = null
  timerArray = []
  /**
   * @param {Number} times // 秒
   * @param {Number} step // 秒
   */
  constructor(times, step = 1) {
    this.times = times
    this.step = step
  }
  start($bus, name) {
    this.isSuspend = false
    // let startTime = new Date().getTime();
    // let count = 0;
    // const handle = () => {
    //   if (this.times > 0) {
    //     if (this.isSuspend) {
    //       return false
    //     } else {
    //       count++
    //       let offset = new Date().getTime() - (startTime + count * 1000);
    //       let nextTime = this.step * 1000 - offset;
    //       if (nextTime < 0) nextTime = 0;
    //       this.times--
    //       setTimeout(handle, nextTime);
    //       $bus && $bus.emit(name, this.times)
    //     }
    //   } else {
    //     this.end()
    //   }
    // }
    // setTimeout(handle, this.step * 1000);
    console.log('this.times', this.times)
    let callback = () => {
      this.timer = setTimeout(() => {
        if (this.times > 0) {
          if (this.isSuspend) {
            return false
          } else {
            this.times--
            callback()
            $bus && $bus.emit(name, this.times)
          }
        } else {
          this.end()
        }
      }, this.step * 1000)
    }
    callback()
  }
  stop() {
    this.timeStart = true
    this.clearTimer()
  }
  suspend() {
    this.isSuspend = true
  }
  end(callback) {
    callback && callback()
  }
  getTimes() {
    return this.times
  }
  clearTimer() {
    // for (let i = 0; i < this.timerArray.length; i++) {
    //   clearTimeout(this.timerArray[i])
    // }
    clearTimeout(this.timer)
  }
}
let timer = new Timer()
timer.install = function (Vue) {
  Vue.prototype.$timer = timer
}
export default timer
